"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStreamStatusAptosOperation = void 0;
exports.updateStreamStatusAptosOperation = {
    method: 'POST',
    name: 'updateStreamStatusAptos',
    id: 'aptosStreamsUpdateStatus',
    groupName: 'aptosStreams',
    urlPathParamNames: ['id'],
    urlPathPattern: '/streams/aptos/{id}/status',
    bodyParamNames: ['status'],
    bodyType: 'properties',
    getRequestUrlParams: getRequestUrlParams,
    getRequestBody: getRequestBody,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        id: request.id,
    };
}
function getRequestBody(request) {
    return {
        status: request.status,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        id: request.id,
        status: request.status,
    };
}
function deserializeRequest(jsonRequest) {
    return {
        id: jsonRequest.id,
        status: jsonRequest.status,
    };
}
//# sourceMappingURL=updateStreamStatusAptosOperation.js.map